import React from 'react';
import { cn } from '@utils';
import {
  FlipIcon,
  GridIcon,
  RotateIcon,
  ZoomInIcon,
  ZoomOutIcon,
} from 'assets/images/toolbar';
import { ImageState } from '../../model/types';
import { BooleanKeys, NumberKeys } from '@types';
import styles from './styles.scss';

type ModsToolbarProps = {
  imageState: ImageState;
  onToggleMode: (mode: BooleanKeys<ImageState>) => void;
  onChangeMode: (mode: NumberKeys<ImageState>, value: number) => void;
};

export const ModsToolbar = ({
  imageState,
  onToggleMode,
  onChangeMode,
}: ModsToolbarProps) => {
  return (
    <div className="flex gap-x-4 items-center">
      <button
        onClick={() => onToggleMode('grid')}
        className={cn(
          styles.previewMode_toolbarButton,
          imageState.grid && 'bg-blue [&>svg>path]:fill-white'
        )}
      >
        <GridIcon />
      </button>
      <button
        onClick={() =>
          onChangeMode('zoom', Math.max(0.25, imageState.zoom - 0.25))
        }
        className={cn(
          styles.previewMode_toolbarButton,
          imageState.zoom === 0.25 &&
            'bg-transparent [&>svg>path]:fill-gray-300 pointer-events-none'
        )}
      >
        <ZoomOutIcon />
      </button>
      <button
        onClick={() =>
          onChangeMode('zoom', Math.min(2, imageState.zoom + 0.25))
        }
        className={cn(
          styles.previewMode_toolbarButton,
          imageState.zoom === 2 &&
            'bg-transparent [&>svg>path]:fill-gray-300 pointer-events-none'
        )}
      >
        <ZoomInIcon />
      </button>
      <button
        onClick={() => onToggleMode('isFlipped')}
        className={cn(
          styles.previewMode_toolbarButton,
          imageState.isFlipped && 'bg-blue [&>svg>path]:fill-white'
        )}
      >
        <FlipIcon />
      </button>
      <button
        onClick={() => onChangeMode('rotate', imageState.rotate + 90)}
        className={styles.previewMode_toolbarButton}
      >
        <RotateIcon />
      </button>
    </div>
  );
};
